<template>
  <div class>
    <div class="submitted_ui">
      <Breadcrumb></Breadcrumb>
      <div class="submitted_info">
        <ul>
          <li class="clearfix">
            <label>项目名称：</label>
            <span>{{form.name}}</span>
            <span class="time"><i class=" el-icon-time"></i>{{form.beginDate}} - {{form.endDate}}</span>
          </li>
          <li class="clearfix">
            <label>项目说明：</label>
            <span class="text">{{form.descr}}</span>
          </li>
          <li class="clearfix">
            <label>项目状态：</label>
            <span>
              <b v-if="form.state==2" class="state-btn2">
              <b></b> 进行中</b>
              <b v-if="form.state==1" class="state-btn1">
                <b></b> 未开始</b>
              <b v-if="form.state==3" class="state-btn3">
                <b></b> 已结束</b>
            </span>
          </li>
          <li class="clearfix" v-if="form.filesNames!=''&&form.files!=''">
            <label>说明文件：</label>
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#iconword" />
              </svg>
              <a class="download" :href="form.files" :download="form.filesNames"> {{form.filesNames}}</a>
              <a class="download download-btn" href="javascript:;" @click="onlinePreview(form)"> 在线预览</a>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="submit-box">
      <p class="title">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconbianji" />
        </svg>
        项目填写
      </p>
      <div class="submit-box-content">
        <el-form
          v-model="labelPosition"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="0"
          class="demo-ruleForm"
        >
          <el-form-item v-for="(item,index) in option" v-if="item.condition==1" :key="index">
            <span class="label-span">
              <b class="xx" v-if="item.state==1">*</b>
              {{item.name}}
            </span>
            <div class="label-right" v-if="item.type==1">
              <el-input
                class="input224"
                v-model="item.value"
                :maxlength="item.wordLimit"
                :disabled="form.show_mySubmitState==1"
              ></el-input>
            </div>
            <div class="label-right" v-if="item.type==7">
              <el-input
                class="input224"
                v-model="item.value"
                :maxlength="item.wordLimit"
                :disabled="form.show_mySubmitState==1"
              ></el-input>
            </div>
            <div class="label-right" v-if="item.type==2" >
              <el-input
                type="textarea"
                
                v-model="item.value"
                :maxlength="item.wordLimit"
                :disabled="form.show_mySubmitState==1"
              ></el-input>
            </div>
            <div class="label-right" v-if="item.type==3">
              <el-input
                class="input224"
                type="number"
                v-model="item.value"
                :maxlength="item.wordLimit"
                :disabled="form.show_mySubmitState==1"
              ></el-input>
            </div>
            <div class="label-right" v-if="item.type==4">
              <el-select
                class="input224"
                v-model="item.value"
                placeholder="请选择"
                :disabled="form.show_mySubmitState==1"
              >
                <el-option v-for="(val,i) in item.datas" :key="i" :label="val" :value="val"></el-option>
              </el-select>
            </div>
            <div class="label-right" v-if="item.type==8">
              <el-select
                class="input224"
                v-model="item.value"
                placeholder="请选择"
                multiple
                :disabled="form.show_mySubmitState==1"
              >
                <el-option v-for="(val,i) in item.datas" :key="i" :label="val" :value="val"></el-option>
              </el-select>
            </div>
            <div class="label-right" v-if="item.type==5">
              <el-upload
                class="upload-demo"
                ref="upload"
                action="/file/upload.ajax"
                :limit="item.wordLimit"
                :disabled="form.show_mySubmitState==1||isJoin==0"
                :data="uploadData"
                :file-list="item.files"
                :on-preview="handlePreview"
                :before-upload="beforeUpload"
                :on-success="(response, file, fileList) => {handleSuccess(response, file, fileList,item,index)}"
                :on-remove="(file, fileList) => {handleRemove(file, fileList,item,index)}"
                :before-remove="beforeRemove"
              >
                <el-button slot="trigger" size="small" type="primary" @click="clickUpload(item)">上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
              <ul class="ul-look" v-if="item.files&&item.files.length>0">
                <li v-for="(val,i) in item.files" :key="i">
                  <el-button
                    slot="trigger"
                    size="small"
                    type="text"
                    @click="onlinePreviewone(val)"
                  >下载</el-button>
                </li>
              </ul>
            </div>
            <div class="label-right" v-if="item.type==6">
              <el-upload
                class="upload-demo"
                ref="upload"
                accept="image/gif, image/jpeg, image/png, image/jpg"
                :limit="item.wordLimit"
                action="/file/upload.ajax"
                :disabled="form.show_mySubmitState==1||isJoin==0"
                :data="uploadData"
                :file-list="item.files"
                :on-preview="handlePreview"
                :before-upload="beforeUpload"
                :on-success="(response, file, fileList) => {handleSuccess(response, file, fileList,item,index)}"
                :on-remove="(file, fileList) => {handleRemove(file, fileList,item,index)}"
                :before-remove="beforeRemove"
              >
                <el-button slot="trigger" size="small" type="primary">上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
              <ul class="ul-look" v-if="item.files&&item.files.length>0">
                <li v-for="(val,i) in item.files" :key="i">
                  <el-button
                    slot="trigger"
                    size="small"
                    type="text"
                    @click="onlinePreviewone(val)"
                  >下载</el-button>
                </li>
              </ul>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn_list clearfix" >
        <a
          href="javascript:;"
          class="border-btn bot-btn"
          style="margin-left:25px;"
          @click="changeState()"
          v-if="form.id!=undefined&&form.state==2&&form.show_mySubmitState==1&&isJoin!=0"
        >编辑</a>
        <a
          href="javascript:;"
          class="border-btn bot-btn"
          style="margin-left:25px;"
          @click="submitForm('ruleForm',0)"
         v-if="form.show_mySubmitState!=1&&form.state==2&&isJoin!=0"
        >保存为草稿</a>
        <a
          href="javascript:;"
          class="change-btn bot-btn"
          style="margin-left:25px;"
          @click="submitForm('ruleForm',1)"
          v-if="form.show_mySubmitState!=1&&form.state==2&&isJoin!=0"
        >提交</a>
      </div>
    </div>
  </div>
</template>

<script>
import {submitProjectDetail, listSubmitProjectField, modifySubmitProjectData, submitProjectDataDetail, updateProjectDataState} from "@/api/common_api";
import { DatePicker,Select } from "element-ui";
import moment from "dayjs";
import { Breadcrumb } from "@/components";

export default {
  components: {
    Breadcrumb,
     "el-select": Select,
  },
  data() {
    return {
      ruleForm: {},
      form: {},
      rules: {},
      labelPosition: "left",
      option: [],
      files: [],
      uploadData: null,
      id: "",
      isJoin:this.$route.query.isJoin,
      submitTemplateId: ""
    };
  },
  created() {
    this.getInfo()
  },
  computed: {
    getText() {}
  },
  methods: {
    onlinePreview(item){
      // var url=form.files
      // var link = document.createElement('a');
      // link.setAttribute("download", file.name);
      // link.href = url;
      // link.click();
      let domain = window.location.host;
      let url = 'http://120.27.241.131:8088/?furl='+window.location.protocol+'//' + domain +item.files
      window.open(url, '_blank')
    },
    onlinePreviewone(file){

      var url=file.url
      var link = document.createElement('a');
      link.setAttribute("download", file.name);
      link.href = url;
      link.click();
      
    },
    handlePreview(file) {
    
      if(file.url){
        var url=file.url
      }else{
        var url=file.response.d.savePath
      }
      let domain = window.location.host;
      let link = 'http://120.27.241.131:8088/?furl='+window.location.protocol+'//' + domain +url
      window.open(link, '_blank')
      // var link = document.createElement('a');
      // link.setAttribute("download", file.name);
      // link.href = url;
      // link.click();
    },
    goBack() {
      this.$router.go(-1);
    },
    changeState() {
      let _this = this

      let obj = {
        submitProjectId:_this.form.submitProjectId|| _this.form.id,
        id: _this.id,
        state: 0
      }
      this.$confirm('此操作将会重置到可编辑状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateProjectDataState(obj).then(res => {
              if (res.s == 1) {
                _this.form.state=2
                _this.form.show_mySubmitState=0
              }
            })
        }).catch(() => {
                  
        });
      
    },
    clickUpload(item){
      this.submitTemplateId = item.id
    },
    beforeUpload(file,id) {
      this.uploadData = { submitProjectId: this.form.id, moduleId: 18,submitTemplateId:this.submitTemplateId};

      let promise = new Promise((resolve) => {
        this.$nextTick(function () {
          resolve(true);
        });
      });
      return promise; //通过返回一个promis对象解决
    },
    handleRemove(file, fileList, item, index) {
      item.value = ''
      item.files.forEach((element,i) => {
          if(element.name==file.name){
            item.files.splice(i,1)
          }
      });
      fileList.forEach(element => {
        
        if (item.value == '') {
          
          item.value = element.response?element.response.d.aaa:element.id;
          
        } else {
          let val=element.response?element.response.d.aaa:element.id
         
          item.value += ',' + val
        }
        // item.files.push({
        //     name:  element.response?element.response.d.originalFilename:element.name,
        //     url: element.response?element.response.d.savePath:element.url,
        //     id:element.response?element.response.d.aaa:element.id
        //   })
      });
    },
    handleSuccess(response, file, fileList, item, index) {
      this.submitTemplateId=""
      if (response.s == 1) {
        if (item.value == '') {
          item.value = response.d.aaa
        } else {
          item.value = item.value + ',' + response.d.aaa
        }
       if(item.files){
          item.files.push({
            name: response.d.originalFilename,
            url: response.d.savePath,
            id:response.d.aaa
          })
       }
      } else {
        fileList.splice(fileList.length-1, 1)
        this.$message.error(response.d);
      }
    },
    beforeRemove(file, fileList) {

      if (file.name == undefined) {
        return this.$confirm('确定删除吗？');
      } else {
        return this.$confirm(`确定移除 ${file.name}？`);
      }

    },
    submitForm(formName, state) {
      let _this = this
     
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.option.forEach(element => {
            if (element.field == 'state') {
              _this.ruleForm.state = state
            } else if (element.field == 'id') {
              _this.ruleForm.id = element.value == '' ? null : element.value
            } else {
              if(JSON.stringify(element.value) === '[]'){
                 _this.ruleForm[element.field] =''
              }else if(element.type==8){
                _this.ruleForm[element.field] = element.value.join(',')
              } else{ 
                _this.ruleForm[element.field] = element.value == undefined ? '' : element.value
              }
              
            }
          });
        
          let obj = {
            submitProjectId: _this.form.submitProjectId || _this.form.id,
            data: JSON.stringify(_this.ruleForm)
          }
          modifySubmitProjectData(obj).then(res => {
            if (res.s == 1) {
              _this.$message({
                message: '操作成功',
                type: 'success'
              });
              
              
            } else {
              _this.$message({
                message: res.d,
                type: 'error'
              });
            }
          })
        } else {
      
          return false;
        }
      });
    },
    getInfo(){
      let _this=this
      let obj={
        id:this.$route.query.id
      }
      submitProjectDetail(obj).then(res=>{
        if (res.s == 1) {
          _this.form=res.d
          _this.form.beginDate = moment(_this.form.beginDate).format('YYYY/MM/DD')
          _this.form.endDate = moment(_this.form.endDate).format('YYYY/MM/DD')
          _this.getList()
        }
         
      })
    },

    getList() {
      let _this = this
      if (_this.form.submitProjectId != undefined) {

        var obj = {
          submitProjectId: _this.form.submitProjectId,
          id: _this.form.id,
        }
      } else {
        var obj = {
          submitProjectId: _this.form.id,
        }
      }

      listSubmitProjectField(obj).then(res => {
        if (res.s == 1) {
          _this.option = res.d;
          _this.option.forEach((element, i) => {
            _this.ruleForm[element.field] = ''
            _this.$set(_this.option[i], 'value', element.defaultValue)
            if (element.state == 1) {
              _this.rules[element.field] = [{
                required: true, message: '请输入' + element.name, trigger: 'blur'
              }]
            }
          });
         if(_this.isshowbtn==undefined){
           submitProjectDataDetail(obj).then(res => {
            if (res.s == 1) {
              var filesName = ''
              var files = ''
              for (const key in res.d) {
                if (res.d.hasOwnProperty(key)) {
                  const val = res.d[key];
                  if (key == 'filesName') {
                    filesName = val.split(',')
                  }
                  if (key == 'files') {
                    files = val.split(',')
                  }
                  if (key == 'id') {
                   _this.id=val
                  }
                  _this.option.forEach((element, i) => {

                    if (key == element.field) {
                      _this.$set(_this.option[i], 'value', val)
                    }
                  });
                }
              }
           
              _this.option.forEach((element, i) => {
                if (element.type == 5||element.type == 6) {
                  if(element.value.length>0){
                    let arr=[]
                    let value=''
                    element.value.forEach((val, index) => {
                      var obj = {
                        name: val.name,
                        url: val.path,
                        id:val.id
                      }
                      arr.push(obj)
                      if(index==0){
                        value=val.id
                      }else{
                        value+=','+val.id
                      }
                    });
                    _this.$set(_this.option[i], 'value', value)
                    _this.$set(_this.option[i], 'files', arr)
                  }
                  
                }
                if(element.type==8){
                  if(element.value.length>0){
                    element.value = element.value.split(',')
                  }else{
                    element.value = []
                  }
                }
              });
            }
          })
         }
          
        }
      })



    },
  }
};
</script>

<style lang="less" scoped>
.icon {
  width: 1.5em;
  height: 1.5em;
  vertical-align: -0.3em;
  fill: currentColor;
  overflow: hidden;
}
.submitted_ui {
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0Px 2Px 4Px 0Px rgba(235, 235, 235, 0.5);
  padding: 0 14Px;
  box-sizing: border-box;
  font-size: 14Px;

  .submitted_info {
    margin-top: 12Px;
    padding-bottom: 28Px;
    ul li {
      margin-top: 15Px;
      label {
        float: left;
        width: 70Px;

        color: #666;
      }
      span {
        float: left;

        color: #444444;
      }
      span.text {
        width: 730Px;
      }
      span.time {
        float: right;
        height: 20Px;
        color: #444;
        font-size: 14Px;
        font-family: PingFangSC-Regular;
        .el-icon-time{
          margin-right:7Px;
          font-size:15Px;
        }
      }
      .download-btn {
        color: #1890ff;
        margin-left: 15Px;
      }
    }
  }
}
.submit-box {
  margin-top: 10Px;
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0Px 2Px 4Px 0Px rgba(235, 235, 235, 0.5);
  padding: 0 14Px;
  box-sizing: border-box;
  font-size: 14Px;
      min-height: 853Px;
  .title {
    color: #909399;
    padding-top: 15Px;
    margin-bottom: 23Px;
  }
  .submit-box-content {
    min-height: 450Px;
    width:420Px;
    margin:0 auto 37Px;
    overflow: auto;
   
    .demo-ruleForm {
      .el-form-item {
        margin-bottom: 20Px !important;
      }
    }
    
  }
  .btn_list{
        border-top: 1Px solid #EEEEEE;
        text-align: center;
        padding-bottom:100Px;
        padding-top:28Px;
    }
  .el-form-item__content {
    
    .label-span {
      font-size: 16Px;
      line-height: 40Px;
      width: 100Px;
      padding-left: 10Px;
      display: inline-block;
      color: #444444;
      text-align: left;
      // overflow: hidden; //超出的文本隐藏
      // text-overflow: ellipsis; //溢出用省略号显示
      // white-space: nowrap; //溢出不换行
      // position:relative
    }
    .label-span.big{
    width: 100%;
    box-sizing: border-box;
    line-height:25Px;
    }
    .xx {
      color: #ff0000;
      position: absolute;
      left: 0;
    }
  }
  .label-right {
    display: inline-block;
    vertical-align: top;
    position: relative;
    .ul-look {
      position: absolute;
      right: -55Px;
      top: 41Px;
    }
  }
  .label-right.big{
    width: 100%;
    box-sizing: border-box;
    .el-textarea__inner{
        min-height:200Px;
    }
}
}
.submit-box.active {
  padding-left: 0;
  height: 550Px;
  .submit-box-content {
    border-bottom: none;
  }
}

/deep/ .el-form-item__content{
  display: flex;
  align-items: center;
}

</style>
